export default __webpack_public_path__ + "static/media/TodilloTransparent.8dbaa41d.png";